var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreatedOnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 31.5,
    height: 31.5,
    rx: 7.75,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 31.5,
    height: 31.5,
    rx: 7.75,
    stroke: "#CFCFCF",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 22.6663L11.8333 19.333H8.5L8.91667 17.6663H12.25L13.0833 14.333H9.75L10.1667 12.6663H13.5L14.3333 9.33301H16L15.1667 12.6663H18.5L19.3333 9.33301H21L20.1667 12.6663H23.5L23.0833 14.333H19.75L18.9167 17.6663H22.25L21.8333 19.333H18.5L17.6667 22.6663H16L16.8333 19.333H13.5L12.6667 22.6663H11ZM13.9167 17.6663H17.25L18.0833 14.333H14.75L13.9167 17.6663Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatedOnIcon);
export default __webpack_public_path__ + "static/media/createdOnIcon.54d71a407dfd0d2996a9f246f0482c03.svg";
export { ForwardRef as ReactComponent };